$(document).ready(function()
{
    if ($('.sortable-table').length)
    {
        $('.sortable-table').dataTable(
        {
            "searching": true,
            "info": true,
            "paging": false,
            "language": {
                search: '<i class="fa fa-filter" aria-hidden="true"></i><span class="show-for-sr">Filter</span>',
                searchPlaceholder: 'Filter table'
            },
            "order": [[ 0, "asc" ]],
            
        });
        
        $("#tableSearcher").html($(".dataTables_filter"));  

    }


    if ($('.sortable-table-none').length)
    {
        $('.sortable-table-none').dataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "order": [[ 0, "asc" ]]
        });
    

    } 

});